import React, { useState } from 'react'
import axios from 'axios';
import {toast} from "react-toastify"
import './applyJob.scss'
function ApplyJob() {
    const jobs = [
        'Kurierfahrer/in',
        'Teamleiter/in',
        'Dispatcher/in',
        'Büroassistent/in',
        'Büroleiter/in',
        'Accountmanager/in',
        'Fleetmanager/in'
    ];

    const [loading,setLoading] = useState(false)
    const [sent,setSent] = useState('')
    const [formValue, setFormValue] = useState({
        username: "",
        email: "",
        mobile: "",
        message: "",
        position: "",
        file: null,
        fileName: ""
    });
    
    const handleChange = (e) => {
        if (e.target.name === "file") {
            const file = e.target.files[0];
            if (file) {
                const maxSize = 7 * 1024 * 1024; // 7MB in bytes
                if (file.size > maxSize) {
                    alert("Maximale grüße ist 7MB.");
                    return;
                }else{
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        setFormValue(prev => ({
                            ...prev,
                            file: reader.result,
                            fileName: file.name
                        }));
                    };
                    reader.readAsDataURL(file);

                }
            }
        } else {
            setFormValue(prev => ({
                ...prev,
                [e.target.name]: e.target.value
            }));
        }
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true)
            const response1 = await axios.post("https://nassco-transport-gmbh-nodemailer.vercel.app/sendEmail", formValue);
  
            if (response1.status === 200) { // Ensure the first request was successful
              await axios.post("https://nassco-transport-gmbh-nodemailer.vercel.app/contactMeReply", formValue);
              setLoading(false)
              setSent('Gesendet, Sie erhalten eine Bestätigungsmail.')
              setFormValue({
                  username: "",
                  email: "",
                  mobile: "",
                  message: "",
                  position: "",
                  file: null,
                  fileName: ""
              });
            } else {
              console.error("First request failed, skipping second request.");
              setSent('Fehler aufgetreten')
              setLoading(false)
            }
        } catch (error) {
            setSent('Fehler aufgetreten')
            setLoading(false)
        }
    };

    return (
        <div className='applyJob'>
            <form onSubmit={handleSubmit}>
                <h1>Bewerben</h1>
                {sent && <h2 className={sent === 'Fehler aufgetreten' ? 'error' : 'done'}>{sent}</h2>}
                <input value={formValue.username} type="text" name="username" placeholder='Name...' required onChange={handleChange} />
                <input value={formValue.email} type="email" name="email" placeholder='E-Mail...' required onChange={handleChange} />
                <input value={formValue.mobile} type="tel" name="mobile" placeholder='Mobile...' required onChange={handleChange} />
                <select name="position" value={formValue.position} required onChange={handleChange}>
                    <option value="" hidden>Wähle deine position...</option>
                    {jobs.map((item, index) => <option key={index} value={item}>{item}</option>)}
                </select>
                <label htmlFor="file">
                    {formValue.fileName ? formValue.fileName : 'Lebenslauf hochladen'}
                   
                    <box-icon name='cloud-upload'></box-icon>
                    <input type="file" name="file" id="file" accept='application/pdf' onChange={handleChange} />
                </label>
                <textarea name="message" value={formValue.message} placeholder='Deine nachricht...' rows={10} required onChange={handleChange}></textarea>
                <small>Alle Felder sind Pflichtfelder</small>
                <button type="submit" disabled={loading || Object.values(formValue)?.some(item => !Boolean(item))}>JETZT BEWERBEN</button>
            </form>
        </div>
    );
}

export default ApplyJob